import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { DrawerFormDataType } from '@/types';

import { useDeleteChannelRecording } from '../api/delete-channel-recording';
import { ChannelRecordingType } from '../types';

type TChannelRecordingsControlllerReturn = {
  channelRecordingDialog: ReturnType<typeof useDisclosureWithData<ChannelRecordingType>>;
  channelRecordingDrawer: ReturnType<
    typeof useDisclosureWithData<DrawerFormDataType<ChannelRecordingType>>
  >;
  handleDeleteChannelRecording: () => void;
};

export function useChannelRecordingsController(): TChannelRecordingsControlllerReturn {
  const channelRecordingDialog = useDisclosureWithData<ChannelRecordingType>();
  const channelRecordingDrawer = useDisclosureWithData<DrawerFormDataType<ChannelRecordingType>>();
  const { mutate: deleteChannelRecording } = useDeleteChannelRecording();

  const handleDeleteChannelRecording = () => {
    if (channelRecordingDialog.data) {
      deleteChannelRecording(
        {
          id: channelRecordingDialog.data.id,
        },
        {
          onSuccess: () => {
            channelRecordingDialog.close();
          },
        }
      );
    }
  };

  return {
    channelRecordingDialog,
    channelRecordingDrawer,
    handleDeleteChannelRecording,
  };
}
